module.exports = __webpack_public_path__ + "static/img/video1.9a2badd4.png";